import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);
const store = new Vuex.Store({
    state: {
        customerId: '',
        mobile: '',
        status: '',
        newsid: '',
        newTypeid: '',
        manager: {},
        resultId: '',
        classId: '',
        className: '',
        schoolId: '',
        schoolName: '',
        provinceId: '',
        cityId: '',
        staffstateProfessId: '',
        staffstateId: '',
        userId: '',
        accountRole: '',
        userName: '',
        token: '',
        loginToken: '',
        avatar: 'https://cube.elemecdn.com/3/7c/3ea6beec64369c2642b92c6726f1epng.png',
        courseId: '',
        assesmentId: '',
        staffId: '',
        studentId: '',
        answerHistory: [],
        dataTime: '',
        pattern: 0,
        isExpertLogin: false
    },
    mutations: {
        courseIdData(state, payload) {
            state.courseId = payload.courseId;
        },
        userName(state, payload) {
            state.userName = payload.userName;
        },
        userPhoto(state, payload) {
            state.avatar = payload.avatar;
        },
        dataTime(state, payload) {
            state.dataTime = payload.dataTime;
        },
        customerData(state, payload) {
            state.customerId = payload.customer_id;
        },
        addNews(state, payload) {
            (state.newsid = payload.newsid), (state.newTypeid = payload.newTypeid);
        },
        managerData(state, payload) {
            state.manager = payload.form;
        },
        resultData(state, payload) {
            state.resultId = payload.resultId;
        },
        classData(state, payload) {
            state.classId = payload.classId;
            state.className = payload.className;
        },
        schoolData(state, payload) {
            state.schoolId = payload.schoolId;
            state.schoolName = payload.schoolName;
            state.provinceId = payload.provinceId;
            state.cityId = payload.cityId;
            state.userId = payload.userId;
            state.accountRole = payload.accountRole;
        },
        platformId(state, payload) {
            state.platformId = payload.platformId;
        },
        staffProfessIdData(state, payload) {
            state.staffstateProfessId = payload.staffstateProfessId;
            state.staffstateId = payload.staffstateId;
        },
        userLoginData(state, payload) {
            state.userId = payload.userId;
            state.accountRole = payload.accountRole;
            // state.staffId = payload.staffId
            state.studentId = payload.studentId;
            state.schoolId = payload.schoolId;
            state.token = payload.token;
        },
        tokenData(state, payload) {
            state.loginToken = payload.loginToken;
        },
        assesmentData(state, payload) {
            state.assesmentId = payload.assesmentId;
        },
        provinceData(state, payload) {
            state.provinceList = payload.provinceList;
        },
        answerHistoryData(state, payload) {
            state.answerHistory = payload.answerHistory;
        },
        patternData(state, payload) {
            state.pattern = payload.pattern;
        },
        expertLogin(state, payload) {
            state.isExpertLogin = payload.isExpertLogin;
        }
    }
});

export default store;
